const Checkbox = ({ entity, name, changeHandler }) => {
    const changeHandlerWrapper = (event) => {
        const {checked} = event.target
        changeHandler(entity.id, name, checked)
    }

    return (
        <input
            type="checkbox"
            checked={entity[name]}
            onChange={changeHandlerWrapper}
        />
    )
}

export default Checkbox